export default {
  iban: '^CH\\d{2}\\s?([0-9a-zA-Z]{4}\\s?){4}[0-9a-zA-Z]{1}$',
  postkonto:
    '^(\\d{1,2}\\s?)(.\\s?){0,1}([0-9]{4,5}\\s?)(.\\s?){0,1}([0-9]{1,2}\\s?)$',
  firstName: /^$|[\u00C0-\u017F-a-zA-Z0-9\\.' ]{3,35}/,
  firstName_no_length: /^$|[\u00C0-\u017F-a-zA-Z0-9\\.' ]{1,35}/,
  lastName: /[\u00C0-\u017F-a-zA-Z0-9\\.' ]{3,60}/,
  lastName_no_length: /[\u00C0-\u017F-a-zA-Z0-9\\.' ]{1,60}/,
  phoneNumber: /^[\\+](([4][1][7][35-9]\d{7})|(([1-35-9]\d|[4][02-9])\d{6,}))$/,
  email:
    /[A-Za-z0-9_]+([-+.'][A-Za-z0-9_]+)*@[A-Za-z0-9_]+([-.][A-Za-z0-9_]+)*\.[A-Za-z0-9_][A-Za-z0-9_]+([-.][A-Za-z0-9_]+)*/,
  houseNumber: '^.{1,8}$',
  zipCode: /^[0-9](\d{3})$/,
  customerNumber: /^[0-9]{2}.?[0-9]{5}-[0-9]$/,
  partner_number: '^[0-9a-z]{32}$',
  partner_number_in_string: '[0-9a-z]{32}',
  insurance_number_in_string: '[0-9]{7}-[0-9]{1}.[0-9]{3}',
  isoDate: /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/,
  collectivePartnerNr: /(K)(\d{6})/,
  collectiveContractNumber: /^(K|P)(\d{6})$/,
}
